/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { TagModel, TagModelType } from "./TagModel"
import { TagModelSelector } from "./TagModel.base"
import { RootStoreType } from "./index"


/**
 * TagSearchResultBase
 * auto generated base class for the model TagSearchResultModel.
 */
export const TagSearchResultModelBase = ModelBase
  .named('TagSearchResult')
  .props({
    __typename: types.optional(types.literal("TagSearchResult"), "TagSearchResult"),
    tags: types.union(types.undefined, types.array(types.late((): any => TagModel))),
    total: types.union(types.undefined, types.integer),
    hasNextPage: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TagSearchResultModelSelector extends QueryBuilder {
  get total() { return this.__attr(`total`) }
  get hasNextPage() { return this.__attr(`hasNextPage`) }
  tags(builder: string | TagModelSelector | ((selector: TagModelSelector) => TagModelSelector) | undefined) { return this.__child(`tags`, TagModelSelector, builder) }
}
export function selectFromTagSearchResult() {
  return new TagSearchResultModelSelector()
}

export const tagSearchResultModelPrimitives = selectFromTagSearchResult().total.hasNextPage
